import React from 'react';
import styled from 'styled-components';
import { ExtraLabelListPopover } from '@shoflo/polymer/components/ExtraLabelListPopover/ExtraLabelListPopover';
import { LabelList } from '@shoflo/polymer/components/label/LabelList';
const LabelWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const EventRowLabelCell = React.memo(({ labels, max, eventId }) => {
  if (!labels || labels.length === 0) return null;

  return (
    <LabelWrapper>
      <LabelList data-testid="event-label" labels={labels} max={max} />
      <ExtraLabelListPopover
        key="2 key"
        labels={labels.slice(max)}
        eventId={eventId}
      />
    </LabelWrapper>
  );
});

EventRowLabelCell.displayName = 'EventRowLabelCell';

export default EventRowLabelCell;
